import React, { Component } from 'react'
import styled, { withTheme } from 'styled-components';
import { Modal } from 'antd';

import { Flex, FlexColumn } from '../../../../Reusable/Container';
import { Tag, Text } from '../../../../Reusable/Text';
import hexToRgba from 'hex-to-rgba';
import BillTable from '../../../Bills/BillTable';
import { getLogoFromDomain, toCurrency, toAbsCurrency } from '../../../../../Utils/util';
import { apiPOSTReq } from '../../../../../Utils/api';
import environment from '../../../../../environment';
import { InitialCircle } from '../../../../Reusable/InitialCircle';
import LucideIcon, { TextButton } from '../../../../Reusable/Button';
import { LucideMessageSquareWarning, LucideTriangleAlert, LucideX } from 'lucide-react';


class VendorCard extends Component {
    state = {
        showBillsModal: false
    }

    componentDidMount() {
        var { vendor } = this.props;
        if(vendor?.id) this.getVendorBills(vendor?.id);
    }

    getVendorBills = (id) => {
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/getVendorBills`, {}, { vendorId: id }, (err, resp) => {
            try {
                const data = resp || {}
                if (data.result) {
                    this.setState({ vendorBills: data.bills, unpaidBillsCount: data.count, totalBillsCount: data.totalBillsCount, paidBillsCount: data.paidBillsCount, vendorCardLoading: false })
                } else {
                    this.setState({ vendorCardLoading: false })
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR /payables/vendors/getVendorBills", error, err, resp)
            }
        })
    }

    render() {
        var { vendor, theme, editMode, bill } = this.props;
        var { showBillsModal, unpaidBillsCount, vendorBills } = this.state;
        vendor = vendor || {};
        
        return (
            <>
                {
                    <Flex between gap='24px'>
                        <Flex start centerHorizontally gap='8px'>
                            <div>
                                <InitialCircle size={50} name={vendor.vendorName} useFirstWordOnly={true} logoUrl={getLogoFromDomain(vendor?.primaryEmail)} />
                            </div>
                            
                            <FlexColumn start gap='4px'>
                                <Flex start centerH gap='8px'>
                                    <Text weight={500} color={theme.colors.primary2} size='14px'>{vendor.vendorName}</Text>
                                    {
                                        vendor.openInboxItemsCount > 0 && 
                                        <Tag primary>{vendor.openInboxItemsCount} New | ${toCurrency(vendor.totalOpenInboxAmount)} total</Tag>
                                    }
                                    {
                                        !vendor.id &&
                                        <Tag>NEW VENDOR</Tag>
                                    }
                                </Flex>
                                {
                                    vendor.id &&
                                    <Flex start gap='4px'>
                                        <Text size={'12px'} height={'14px'} weight={500} color={hexToRgba(this.props.theme.colors.primary2, 0.5)}>Balance: ${toCurrency(vendor.outstandingBalance)}</Text>
                                        {vendor.overdueBillsCount > 0 && <Text size={'12px'} height={'14px'} weight={500} color={hexToRgba(theme.colors.primary2, 0.5)}>| {vendor.overdueBillsCount} bills overdue</Text>}
                                        { (vendorBills || []).length > 0 && <Text size={'12px'} height={'14px'} weight={500} color={hexToRgba(theme.colors.primary2, 0.5)}>| <a style={{ textDecoration: "underline", color: hexToRgba(theme.colors.primary2, 0.8) }} onClick={() => this.setState({ showBillsModal: true })}>{unpaidBillsCount} unpaid bills</a></Text> }
                                    </Flex>
                                }
                            </FlexColumn>
                        </Flex>
                        {
                            editMode &&
                            <a style={{ textDecoration: "underline", color: hexToRgba(theme.colors.primary2, 0.6), fontSize: '14px' }} onClick={() => this.props.onEdit()}>Edit</a>
                        }
                        {
                            !vendor.id && !editMode &&
                            <Flex centerH gap='6px'>
                                <LucideMessageSquareWarning size='20px' color={hexToRgba(theme.colors.primary6, 1)} />
                                {/* <TextButton size='13px' onClick={() => this.props.loadStep("NewVendor")} text={"SETUP VENDOR"} /> */}
                                <a style={{ textDecoration: "underline", color: hexToRgba(theme.colors.primary2, 0.6), fontSize: '14px' }} onClick={() => this.props.loadStep("NewVendor")} text={"Setup Vendor"}>Setup Vendor</a>
                            </Flex>
                            
                        }
                    </Flex>
                }
                <Modal
                    visible={showBillsModal}
                    footer={null}
                    closable={true}
                    maskClosable={true}
                    width={800}
                    style={{ top: 20, minHeight: "800px" }}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ showBillsModal: false })}
                    closeIcon={<LucideIcon icon={LucideX} />}
                >
                    <FlexColumn style={{margin: '40px 20px'}}>
                        <BillTable 
                            activeTab={"Unpaid"}
                            bills={vendorBills}
                            pagination={{}}
                            titleText={"Unpaid bills from " + vendor.vendorName}
                            descText={`Unpaid bills from this vendor. Balance to be paid $${toAbsCurrency(vendor.outstandingBalance)}`}
                            hideColumns={["vendorName", "status"]}                                
                            hideAction={true}
                            borderView={true}
                            customBillTag={bill?.invoiceNumber && { [bill?.invoiceNumber]: "Current bill" }}
                        />
                    </FlexColumn>
                </Modal>
            </>
            
        )
    }
}

export default withTheme(VendorCard)